import * as React from 'react';
import parse from 'html-react-parser';

// activity_info is raw HTML; split on top-level <h3> so each section can render as its own card.
const UnitTemplateProfileDescription = ({ data }) => {
  if (!data.activity_info) {
    return <div className="unit-template-profile-description" />
  }

  const parsed = parse(data.activity_info)
  const nodesRaw = Array.isArray(parsed) ? parsed : [parsed]

  // Activity_info authors use bare `<h3></h3>` as visual spacers between sections;
  // treating those as section breaks produces cards with empty headers and no body.
  const h3HasText = (node: React.ReactNode) => {
    if (!React.isValidElement(node) || node.type !== 'h3') return false
    const text = React.Children.toArray(node.props.children)
      .map(c => typeof c === 'string' ? c : '')
      .join('')
      .trim()
    return text.length > 0
  }
  const nodes = nodesRaw.filter(n =>
    !(React.isValidElement(n) && n.type === 'h3' && !h3HasText(n))
  )

  const trimTrailingBreaks = (section: React.ReactNode[]) => {
    while (section.length > 0) {
      const last = section[section.length - 1]
      const isBr = React.isValidElement(last) && last.type === 'br'
      const isBlankText = typeof last === 'string' && last.trim() === ''
      if (isBr || isBlankText) {
        section.pop()
      } else {
        break
      }
    }
  }

  const sections: React.ReactNode[][] = []
  let current: React.ReactNode[] = []

  nodes.forEach((node) => {
    const isH3 = React.isValidElement(node) && node.type === 'h3'
    if (isH3 && current.length > 0) {
      trimTrailingBreaks(current)
      if (current.length > 0) sections.push(current)
      current = []
    }
    current.push(node)
  })

  trimTrailingBreaks(current)
  if (current.length > 0) sections.push(current)

  const renderChildren = (children: React.ReactNode[], offset: number) =>
    children.map((node, j) => (
      <React.Fragment key={offset + j}>{node}</React.Fragment>
    ))

  return (
    <div className="unit-template-profile-description">
      {sections.map((sectionNodes, i) => {
        const first = sectionNodes[0]
        const firstIsH3 = React.isValidElement(first) && first.type === 'h3'
        if (firstIsH3) {
          return (
            <section className="description-card" key={i}>
              <header className="description-card-header">{first}</header>
              <div className="description-card-body">{renderChildren(sectionNodes.slice(1), 1)}</div>
            </section>
          )
        }
        return (
          <section className="description-card" key={i}>
            <div className="description-card-body">{renderChildren(sectionNodes, 0)}</div>
          </section>
        )
      })}
    </div>
  )
}

export default UnitTemplateProfileDescription;
